import React, { useState, useContext, useEffect, useMemo, useCallback } from "react";
import ReactDOM from "react-dom";
import * as MaterialUI from "@material-ui/core";
import { useHistory } from "react-router-dom";
import clsx from "clsx";
import {
  makeStyles,
  Drawer,
  AppBar,
  Toolbar,
  List,
  Typography,
  Divider,
  Button,
  MenuItem,
  IconButton,
  Menu,
  useTheme,
  useMediaQuery,
  Avatar,
  Badge,
  withStyles,
  Chip,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  ListItem,
  ListItemAvatar,
  ListItemText,
} from "@material-ui/core";
import MenuIcon from "@material-ui/icons/Menu";
import ChevronLeftIcon from "@material-ui/icons/ChevronLeft";
import NotificationsIcon from "@material-ui/icons/Notifications";
import NotificationsActiveIcon from "@material-ui/icons/NotificationsActive";
import AccessTimeIcon from "@material-ui/icons/AccessTime";
import alertSound from "../assets/sound.mp3";
import api from "../services/api";
import { WhatsAppsContext } from "../context/WhatsApp/WhatsAppsContext";
import MainListItems from "./MainListItems";
import NavbarSlot from "../components/PluginBridge/slots/NavbarSlot";
import PluginHtmlModalHost from "../components/PluginBridge/PluginHtmlModalHost";
import PluginBridge from "../components/PluginBridge";
import { app as appUI, PluginRuntime, RUNTIME_EVENTS, i18nUseApp } from "@markedesk/plugin-sdk/ui";
import UserModal from "../components/UserModal";
import { AuthContext } from "../context/Auth/AuthContext";
import BackdropLoading from "../components/BackdropLoading";
import { i18n } from "../translate/i18n";
import { toast } from "react-toastify";
import toastError from "../errors/toastError";
import BirthdayModal from "../components/BirthdayModal";
import logo from "../assets/logo.png";
import logoDark from "../assets/logo-black.png";
import { useDate } from "../hooks/useDate";
import ColorModeContext from "../layout/themeContext";
import CompanyBlockingMiddleware from "../components/CompanyBlockingMiddleware";
import SyncStatusOverlay from "../components/SyncStatusOverlay";
import { getBackendUrl } from "../config";
import useSettings from "../hooks/useSettings";
import VersionControl from "../components/VersionControl";
import useSocketListener from "../hooks/useSocketListener";
import { AudioPlayerProvider } from "../context/AudioPlayer/AudioPlayerContext";
import GlobalAudioPlayer from "../components/GlobalAudioPlayer";

const backendUrl = getBackendUrl();
const drawerWidth = 240;


const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
    height: "100vh",
    [theme.breakpoints.down("sm")]: {
      height: "calc(100vh - 56px)",
    },
    backgroundColor: theme.palette.fancyBackground,
    "& .MuiButton-outlinedPrimary": {
      color: theme.palette.primary.main, // Usa cor do tema
      border: `1px solid ${theme.palette.primary.main}40`,
      borderRadius: "8px",
      fontWeight: 600,
      textTransform: "none",
      transition: "all 0.3s ease",
      "&:hover": {
        backgroundColor: `${theme.palette.primary.main}10`,
        borderColor: theme.palette.primary.main,
        transform: "translateY(-1px)",
        boxShadow: `0 4px 12px ${theme.palette.primary.main}30`,
      },
    },
    "& .MuiTab-textColorPrimary.Mui-selected": {
      color: theme.palette.primary.main, // Usa cor do tema
      fontWeight: 700,
    },
  },

  chip: {
    background: "red",
    color: "white",
  },

  avatar: {
    width: "100%",
  },

  toolbar: {
    paddingRight: 24,
    color: theme.palette.dark.main,
    // Usa a cor primária do tema para o fundo do AppBar
    background: theme.palette.primary.main, // Mudança principal aqui
    boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)", // Sombra sutil
    transition: "all 0.3s ease",
  },

  toolbarIcon: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    padding: "0 8px",
    minHeight: "48px",
    [theme.breakpoints.down("sm")]: {
      height: "48px",
    },
    // ALTERAÇÃO: Removido o gradiente e definido fundo branco
    backgroundColor: "#ffffff", // Fundo branco fixo
    borderBottom: `1px solid ${theme.palette.divider}`, // Linha sutil para separação
    transition: "all 0.3s ease",
  },

  appBar: {
    zIndex: theme.zIndex.drawer + 1,
    transition: theme.transitions.create(["width", "margin"], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
  },

  appBarShift: {
    marginLeft: drawerWidth,
    width: `calc(100% - ${drawerWidth}px)`,
    transition: theme.transitions.create(["width", "margin"], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
    [theme.breakpoints.down("sm")]: {
      display: "none",
    },
  },

  menuButtonHidden: {
    display: "none",
  },

  title: {
    flexGrow: 1,
    fontSize: 14,
    color: "white",
    fontWeight: 600,
    letterSpacing: "0.025em",
  },

  drawerPaper: {
    position: "relative",
    whiteSpace: "nowrap",
    width: drawerWidth,
    transition: theme.transitions.create("width", {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
    overflowX: "hidden",
    overflowY: "hidden",
    // Melhorias sutis no drawer
    borderRight: `1px solid ${theme.mode === "light" ? "#e0e0e0" : "#424242"}`,
    boxShadow:
      theme.mode === "light"
        ? "2px 0 8px rgba(0, 0, 0, 0.1)"
        : "2px 0 8px rgba(0, 0, 0, 0.3)",
  },

  drawerPaperClose: {
    overflowX: "hidden",
    overflowY: "hidden",
    transition: theme.transitions.create("width", {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    width: theme.spacing(7),
    [theme.breakpoints.up("sm")]: {
      width: theme.spacing(9),
    },
  },

  appBarSpacer: {
    minHeight: "48px",
  },

  content: {
    flex: 1,
    overflow: "auto",
    padding: 0,
    margin: 0,
  },

  container: {
    padding: 0,
    margin: 0,
    maxWidth: "none",
    width: "100%",
  },

  containerWithScroll: {
    flex: 1,
    overflowY: "scroll",
    overflowX: "hidden",
    ...theme.scrollbarStyles,
    borderRadius: "8px",
    border: "2px solid transparent",
    "&::-webkit-scrollbar": {
      display: "none",
    },
    "-ms-overflow-style": "none",
    "scrollbar-width": "none",
  },

  NotificationsPopOver: {
    // Mantém original
  },

  logo: {
    width: "100%",
    height: "45px",
    maxWidth: 180,
    [theme.breakpoints.down("sm")]: {
      width: "auto",
      height: "100%",
      maxWidth: 180,
    },
    logo: theme.logo,
    content:
      "url(" +
      (theme.mode === "light"
        ? theme.calculatedLogoLight()
        : theme.calculatedLogoDark()) +
      ")",
    transition: "all 0.3s ease", // Transição suave
    "&:hover": {
      transform: "scale(1.02)", // Pequeno zoom no hover
    },
  },

  hideLogo: {
    display: "none",
  },

  avatar2: {
    width: theme.spacing(4),
    height: theme.spacing(4),
    cursor: "pointer",
    borderRadius: "50%",
    border: "2px solid #ccc",
    transition: "all 0.3s ease",
    "&:hover": {
      transform: "scale(1.05)",
      borderColor: theme.palette.primary.main, // Usa cor do tema
    },
  },

  updateDiv: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
  },

  // Botões da toolbar melhorados
  toolbarButton: {
    color: "rgba(255, 255, 255, 0.9)",
    borderRadius: "8px",
    padding: "8px",
    margin: "0 2px",
    transition: "all 0.3s ease",
    "&:hover": {
      backgroundColor: "rgba(255, 255, 255, 0.1)",
      transform: "translateY(-1px)",
    },
    "&:active": {
      transform: "translateY(0)",
    },
  },

  // Menu hambúrguer com animação sutil
  menuButton: {
    color: "white",
    "&:hover": {
      backgroundColor: "rgba(255, 255, 255, 0.1)",
    },
    "& .MuiSvgIcon-root": {
      transition: "transform 0.3s ease",
    },
    "&:hover .MuiSvgIcon-root": {
      transform: "rotate(90deg)",
    },
  },

  // Seletor de idioma melhorado
  languageSelector: {
    position: "relative",
    display: "inline-block",
    "& > button": {
      background: "rgba(255, 255, 255, 0.1)",
      border: "none",
      borderRadius: "8px",
      color: "rgba(255, 255, 255, 0.9)",
      fontSize: "18px",
      padding: "8px 12px",
      cursor: "pointer",
      transition: "all 0.3s ease",
      "&:hover": {
        background: "rgba(255, 255, 255, 0.2)",
        transform: "translateY(-1px)",
      },
    },
    "& > div": {
      position: "absolute",
      top: "45px",
      left: "0",
      background: "#fff",
      boxShadow: "0 4px 12px rgba(0, 0, 0, 0.15)",
      borderRadius: "8px",
      padding: "8px",
      zIndex: 1000,
      minWidth: "120px",
      "& button": {
        background: "none",
        border: "none",
        color: "#374151",
        display: "block",
        width: "100%",
        padding: "8px 12px",
        textAlign: "left",
        borderRadius: "6px",
        fontSize: "14px",
        fontWeight: 500,
        transition: "all 0.2s ease",
        "&:hover": {
          background: `${theme.palette.primary.main}10`, // Usa cor do tema
          color: theme.palette.primary.main, // Usa cor do tema
          transform: "none",
        },
      },
    },
  },

  // Badge animado
  animatedBadge: {
    "& .MuiBadge-badge": {
      animation: "$heartbeat 2s infinite",
    },
  },

  "@keyframes heartbeat": {
    "0%": { transform: "scale(1)" },
    "14%": { transform: "scale(1.1)" },
    "28%": { transform: "scale(1)" },
    "42%": { transform: "scale(1.1)" },
    "70%": { transform: "scale(1)" },
  },
}));

const StyledBadge = withStyles((theme) => ({
  badge: {
    backgroundColor: "#44b700",
    color: "#44b700",
    boxShadow: `0 0 0 2px ${theme.palette.background.paper}`,
    "&::after": {
      position: "absolute",
      top: 0,
      left: 0,
      width: "100%",
      height: "100%",
      borderRadius: "50%",
      animation: "$ripple 1.2s infinite ease-in-out",
      border: "1px solid currentColor",
      content: '""',
    },
  },
  "@keyframes ripple": {
    "0%": {
      transform: "scale(.8)",
      opacity: 1,
    },
    "100%": {
      transform: "scale(2.4)",
      opacity: 0,
    },
  },
}))(Badge);

const SmallAvatar = withStyles((theme) => ({
  root: {
    width: 22,
    height: 22,
    border: `2px solid ${theme.palette.background.paper}`,
  },
}))(Avatar);

const LoggedInLayout = ({ children, themeToggle }) => {
  const classes = useStyles();
  const [userModalOpen, setUserModalOpen] = useState(false);
  const [anchorEl, setAnchorEl] = useState(null);
  const [menuOpen, setMenuOpen] = useState(false);
  const { handleLogout, loading, user, socket } = useContext(AuthContext);
  const { whatsApps } = useContext(WhatsAppsContext);
  const history = useHistory();
  const [drawerOpen, setDrawerOpen] = useState(false);
  const [drawerVariant, setDrawerVariant] = useState("permanent");

  // Alimenta o PluginRuntime (store central exposto aos plugins): contexto da
  // sessão + ações de alto nível + eventos a partir dos sockets que o app já
  // escuta. Plugins reusam sem puxar de AuthContext nem abrir socket próprio.
  useEffect(() => {
    const companyId = user?.companyId;
    PluginRuntime.configure({
      socket,
      user,
      companyId,
      // React/ReactDOM do app no Runtime — superfície única dos plugins. Plugin
      // monta componentes React reais via PluginRuntime.react (mesma instância).
      // Acessado por window.markedeskRuntime.react no frontendScript serializado
      // (nome fixo em global → à prova de minificação do app e do plugin).
      react: React,
      reactDOM: ReactDOM,
      // Material-UI do app: e o que permite a tela de um plugin sair com a
      // cara do sistema (tema, modo escuro, tipografia) sem bundle proprio.
      mui: MaterialUI,
      connections: whatsApps || [],
      // Idioma da INTERFACE. Não vem do usuário no banco (não existe coluna
      // para isso): quem decide é o i18next, pelo que o usuário escolheu no
      // menu ou pelo navegador. Sem expor aqui, um plugin que queira falar a
      // língua do usuário só teria a saída de ler `localStorage.i18nextLng`
      // por fora — ou seja, adivinhar o detalhe de implementação do app.
      idioma: i18n.language,
      userSettings: user
        ? {
            allUserChat: user.allUserChat,
            allowGroup: user.allowGroup,
            startWork: user.startWork,
            endWork: user.endWork,
            defaultTheme: user.defaultTheme,
            profile: user.profile,
          }
        : null,
    });

    // O i18n do app tambem recebe os textos dos plugins (namespace = pluginId),
    // entao `i18n.t("aia-tools:usarResposta")` funciona como qualquer chave.
    i18nUseApp(i18n);

    // Ações de alto nível que SÓ o front sabe fazer (frente híbrida).
    PluginRuntime.registerActions({
      navigate: (path) => { try { history.push(path); } catch (e) { /* noop */ } },
      openTicket: (ticketId) => { try { history.push(`/tickets/${ticketId}`); } catch (e) { /* noop */ } },
    });

    if (!socket || !companyId) return undefined;

    // Reemite os sockets do app como eventos do runtime (push → plugins).
    // Nomes vindos do SDK (RUNTIME_EVENTS): quem emite é aqui e quem assina é o
    // plugin — eram duas pontas digitando a mesma string na mão.
    const onAppMessage = (data) => PluginRuntime.emit(RUNTIME_EVENTS.TICKET_MESSAGE, data);
    const onTicket = (data) => PluginRuntime.emit(RUNTIME_EVENTS.TICKET_UPDATED, data);
    const onContact = (data) => PluginRuntime.emit(RUNTIME_EVENTS.CONTACT_UPDATED, data);
    const onWhatsapp = (data) => PluginRuntime.emit(RUNTIME_EVENTS.CONNECTION_STATUS, data);

    socket.on(`company-${companyId}-appMessage`, onAppMessage);
    socket.on(`company-${companyId}-ticket`, onTicket);
    socket.on(`company-${companyId}-contact`, onContact);
    socket.on(`company-${companyId}-whatsapp`, onWhatsapp);

    return () => {
      socket.off(`company-${companyId}-appMessage`, onAppMessage);
      socket.off(`company-${companyId}-ticket`, onTicket);
      socket.off(`company-${companyId}-contact`, onContact);
      socket.off(`company-${companyId}-whatsapp`, onWhatsapp);
    };
  }, [socket, user, whatsApps, history]);

  // Troca de idioma no menu não re-renderiza este componente, então o
  // `configure` acima guardaria para sempre o idioma do primeiro render. Ouvir
  // o i18next é o que mantém o runtime contando a verdade depois da troca.
  useEffect(() => {
    const aoTrocarIdioma = (lng) => {
      PluginRuntime.configure({ idioma: lng });
      PluginRuntime.emit("locale:change", lng);
    };
    i18n.on("languageChanged", aoTrocarIdioma);
    return () => { i18n.off("languageChanged", aoTrocarIdioma); };
  }, []);

  // Busca uma vez a config da empresa e alimenta o runtime.
  useEffect(() => {
    if (!user?.companyId) return;
    let alive = true;
    api.get("/companySettings")
      .then((res) => { if (alive) PluginRuntime.configure({ companySettings: res?.data || null }); })
      .catch(() => { /* noop */ });
    return () => { alive = false; };
  }, [user?.companyId]);

  const [showOptions, setShowOptions] = useState(false);
  const [showAnnouncementsModal, setShowAnnouncementsModal] = useState(false);
  const [announcements, setAnnouncements] = useState([]);
  const [selectedAnnouncement, setSelectedAnnouncement] = useState(null);
  const [showBirthdayModal, setShowBirthdayModal] = useState(false);

  const theme = useTheme();
  const { colorMode } = useContext(ColorModeContext);
  const greaterThenSm = useMediaQuery(theme.breakpoints.up("sm"));

  const [volume, setVolume] = useState(localStorage.getItem("volume") || 1);

  const { dateToClient } = useDate();
  const [profileUrl, setProfileUrl] = useState(null);
const [updateInProgress, setUpdateInProgress] = useState(false);
const [taskReminderData, setTaskReminderData] = useState(null);


  // eslint-disable-next-line react-hooks/exhaustive-deps
  const mainListItems = useMemo(
    () => <MainListItems drawerOpen={drawerOpen} collapsed={!drawerOpen} />,
    [user, drawerOpen]
  );

  const settings = useSettings();

  useEffect(() => {
    const fetchAnnouncements = async () => {
      try {
        const { data } = await api.get("/announcements/for-company", {
          params: {
            status: true,
            pageNumber: "1"
          }
        });
  
        // Filtra apenas os informativos ativos e não expirados
        const activeAnnouncements = data.records.filter(announcement => {
          const isActive = announcement.status === true || announcement.status === "true";
          const isNotExpired = !announcement.expiresAt || new Date(announcement.expiresAt) > new Date();
          return isActive && isNotExpired;
        });
  
        setAnnouncements(activeAnnouncements);
        
        // Mostra o modal apenas se houver informativos ativos
        if (activeAnnouncements.length > 0) {
          setShowAnnouncementsModal(true);
        }
      } catch (err) {
        toastError(err);
      }
    };
  
    if (user?.id) {
      fetchAnnouncements();
    }
  }, [user?.id]);

  useEffect(() => {
    // if (localStorage.getItem("public-token") === null) {
    //   handleLogout()
    // }

    if (document.body.offsetWidth > 600) {
      if (user.defaultMenu === "closed") {
        setDrawerOpen(false);
      } else {
        setDrawerOpen(true);
      }
    }
    if (user.defaultTheme === "dark" && theme.mode === "light") {
      colorMode.toggleColorMode();
    }
  }, [user.defaultMenu, document.body.offsetWidth]);

  useEffect(() => {
    if (document.body.offsetWidth < 600) {
      setDrawerVariant("temporary");
    } else {
      setDrawerVariant("permanent");
    }
  }, [drawerOpen]);

  useEffect(() => {
  const companyId = user?.companyId;
  
  if (companyId) {
    const buildProfileUrl = () => {
      const savedProfileImage = localStorage.getItem("profileImage");
      const currentProfileImage = savedProfileImage || user.profileImage;
      
      if (currentProfileImage) {
        return `${backendUrl}/public/company${companyId}/user/${currentProfileImage}`;
      }
      return `${backendUrl}/public/app/noimage.png`;
    };

    setProfileUrl(buildProfileUrl());
  }
}, [user?.companyId, user?.profileImage, backendUrl]);

// Callbacks dos eventos
const handleAuthEvent = useCallback((data) => {
  if (data.user.id === +user?.id) {
    toastError("Sua conta foi acessada em outro computador.");
    setTimeout(() => {
      localStorage.clear();
      window.location.reload();
    }, 1000);
  }
}, [user?.id]);

const handleUserUpdate = useCallback((data) => {
  if (data.action === "update" && data.user.id === +user?.id) {
    if (data.user.profileImage) {
      const newProfileUrl = `${backendUrl}/public/company${user?.companyId}/user/${data.user.profileImage}`;
      setProfileUrl(newProfileUrl);
      localStorage.setItem("profileImage", data.user.profileImage);
    }
  }
}, [user?.companyId, user?.id, backendUrl]);

// Callbacks para eventos de aniversário
const handleUserBirthday = useCallback((data) => {
  console.log("🎂 Evento de aniversário de usuário recebido:", data);
  if (data.userId === +user?.id) {
    setShowBirthdayModal(true);
  }
}, [user?.id]);

const handleContactBirthday = useCallback((data) => {
  console.log("🎂 Evento de aniversário de contato recebido:", data);
  // Para contatos, apenas logamos por enquanto
  // A mensagem já foi enviada automaticamente pelo backend
}, []);

// Verificar aniversários no login
const checkBirthdaysOnLogin = useCallback(async () => {
  if (user?.id && user?.companyId) {
    try {
      const { data } = await api.get("/birthdays/today");
      const birthdayData = data.data;
      
      // Verificar se o usuário atual faz aniversário hoje
      const userBirthday = birthdayData.users.find(u => u.id === +user.id);
      if (userBirthday) {
        console.log("🎂 Usuário faz aniversário hoje! Mostrando modal...");
        setShowBirthdayModal(true);
      }
      
      // Se há aniversariantes, mostrar notificação
      if (birthdayData.users.length > 0 || birthdayData.contacts.length > 0) {
        console.log("🎂 Há aniversariantes hoje:", birthdayData);
      }
    } catch (error) {
      console.error("Erro ao verificar aniversários:", error);
    }
  }
}, [user?.id, user?.companyId]);

// Registrar listeners
useSocketListener(socket, user, 'auth', handleAuthEvent);
useSocketListener(socket, user, 'user', handleUserUpdate);
useSocketListener(socket, user, 'user-birthday', handleUserBirthday);
useSocketListener(socket, user, 'contact-birthday', handleContactBirthday);

// Listener de lembretes de tarefas
useEffect(() => {
  if (!socket || !user?.companyId) return;
  const eventName = `company${user.companyId}-task-reminder`;
  const handleTaskReminder = (data) => {
    if (data.action === "reminder" && data.task) {
      // Só notifica se a tarefa for atribuída ao usuário atual ou a ninguém (todos)
      const assignedIds = data.task.assignedToUserIds;
      if (Array.isArray(assignedIds) && assignedIds.length > 0 && !assignedIds.includes(user.id)) return;

      setTaskReminderData(data.task);
      try {
        const audio = new Audio(alertSound);
        audio.volume = volume || 1;
        audio.play().catch(() => {});
      } catch (e) {}
    }
  };
  socket.on(eventName, handleTaskReminder);
  return () => socket.off(eventName, handleTaskReminder);
}, [socket, user?.companyId, volume]);

// Verificar aniversários quando o usuário faz login
useEffect(() => {
  if (user?.id && user?.companyId) {
    // Pequeno delay para garantir que o socket esteja conectado
    const timer = setTimeout(() => {
      checkBirthdaysOnLogin();
    }, 1000);
    
    return () => clearTimeout(timer);
  }
}, [user?.id, user?.companyId, checkBirthdaysOnLogin]);

// Status do usuário
useEffect(() => {
  if (socket?.emit && user?.companyId) {
    socket.emit("userStatus");
    
    const interval = setInterval(() => {
      socket?.emit && socket.emit("userStatus");
    }, 1000 * 60 * 5);

    return () => clearInterval(interval);
  }
}, [socket, user?.companyId]);

    const handleUpdateStart = () => {
    setUpdateInProgress(true);
  };

  const handleUpdateComplete = () => {
    setUpdateInProgress(false);
  };

  const handleMenu = (event) => {
    setAnchorEl(event.currentTarget);
    setMenuOpen(true);
  };

  const handleCloseMenu = () => {
    setAnchorEl(null);
    setMenuOpen(false);
  };

  const handleOpenUserModal = () => {
    setUserModalOpen(true);
    handleCloseMenu();
  };

  const handleClickLogout = () => {
    handleCloseMenu();
    handleLogout();
  };

  const drawerClose = () => {
    if (document.body.offsetWidth < 600 || user.defaultMenu === "closed") {
      setDrawerOpen(false);
    }
  };

  const handleRefreshPage = () => {
    window.location.reload(false);
  };

  const handleMenuItemClick = () => {
    const { innerWidth: width } = window;
    if (width <= 600) {
      setDrawerOpen(false);
    }
  };

  const handleLanguageChange = (lng) => {
    i18n.changeLanguage(lng);
    localStorage.setItem("language", lng);
    window.location.reload();
  };

  const LANGUAGE_OPTIONS = [
    { code: "pt-BR", label: "Português" },
    { code: "en", label: "English" },
    { code: "es", label: "Spanish" },
    { code: "ar", label: "عربي" },
  ];

  const [enabledLanguages, setEnabledLanguages] = useState(["pt-BR", "en"]);
  const { getAll } = useSettings();
  useEffect(() => {
    async function fetchSettings() {
      try {
        const settings = await getAll();
        const enabledLanguagesSetting = settings.find(
          (s) => s.key === "enabledLanguages"
        )?.value;
        let langs = ["pt-BR", "en"];
        try {
          if (enabledLanguagesSetting) {
            langs = JSON.parse(enabledLanguagesSetting);
          }
        } catch { }
        console.log(
          "Layout - enabledLanguages carregadas:",
          langs,
          "para companyId:",
          user?.companyId
        );
        setEnabledLanguages(langs);
      } catch (error) {
        console.log("Layout - erro ao carregar enabledLanguages:", error);
      }
    }
    fetchSettings();
  }, [user?.companyId]);

  const filteredLanguageOptions = LANGUAGE_OPTIONS.filter((lang) =>
    enabledLanguages.includes(lang.code)
  );

    if (loading || updateInProgress) {
    return <BackdropLoading />;
  }

  return (
    <AudioPlayerProvider>
    <div className={clsx(classes.root, "logged-in-layout")}>
      <Drawer
        variant={drawerVariant}
        className={drawerOpen ? classes.drawerPaper : classes.drawerPaperClose}
        classes={{
          paper: clsx(
            classes.drawerPaper,
            !drawerOpen && classes.drawerPaperClose
          ),
        }}
        open={drawerOpen}
      >
        <div className={classes.toolbarIcon}>
          <img
            className={drawerOpen ? classes.logo : classes.hideLogo}
            style={{
              display: "block",
              margin: "0 auto",
              height: "50px",
              width: "100%",
            }}
            alt="logo"
          />
          <IconButton onClick={() => setDrawerOpen(!drawerOpen)}>
            <ChevronLeftIcon />
          </IconButton>
        </div>
        <List className={classes.containerWithScroll}>
          {/* {mainListItems} */}
          <MainListItems collapsed={!drawerOpen} />
        </List>
        <Divider />
      </Drawer>

      <AppBar
        position="absolute"
        className={clsx(classes.appBar, drawerOpen && classes.appBarShift)}
        color="primary"
      >
        <Toolbar variant="dense" className={classes.toolbar}>
          <IconButton
            edge="start"
            variant="contained"
            aria-label="open drawer"
            style={{ color: "white" }}
            onClick={() => setDrawerOpen(!drawerOpen)}
            className={clsx(drawerOpen && classes.menuButtonHidden)}
          >
            <MenuIcon />
          </IconButton>

          <Typography
            component="h2"
            variant="h6"
            color="inherit"
            noWrap
            className={classes.title}
          >
            {/* {greaterThenSm && user?.profile === "admin" && getDateAndDifDays(user?.company?.dueDate).difData < 7 ? ( */}
            {greaterThenSm &&
              user?.profile === "admin" &&
              user?.company?.dueDate ? (
              <>
                {i18n.t("mainDrawer.appBar.user.message")} <b>{user.name}</b>,{" "}
                {i18n.t("mainDrawer.appBar.user.messageEnd")}{" "}
                <b>{user?.company?.name}</b>! (
                {i18n.t("mainDrawer.appBar.user.active")}{" "}
                {dateToClient(user?.company?.dueDate)})
              </>
            ) : (
              <>
                {i18n.t("mainDrawer.appBar.user.message")} <b>{user.name}</b>,{" "}
                {i18n.t("mainDrawer.appBar.user.messageEnd")}{" "}
                <b>{user?.company?.name}</b>!
              </>
            )}
          </Typography>

          <VersionControl 
            onUpdateStart={handleUpdateStart}
            onUpdateComplete={handleUpdateComplete}
          />

          {/* Navbar declarativa: a barra inteira é um PluginBridge do slot
              NAVBAR. O conteúdo nativo (NavbarSlot) é o children — cada botão é,
              por sua vez, um PluginBridge do seu sub-slot (NAVBAR_*). Ações de
              plugin gerais do slot NAVBAR aparecem após o conteúdo nativo.
              (VersionControl fica fora por acoplar ao loading do layout.) */}
          {user.id && (
            <PluginBridge slot={appUI.slots.NAVBAR} as="buttons" context={{}}>
              <NavbarSlot context={{}} volume={volume} setVolume={setVolume} />
            </PluginBridge>
          )}

          <div className="user-menu-wrapper">
            <StyledBadge
              overlap="circular"
              anchorOrigin={{
                vertical: "bottom",
                horizontal: "right",
              }}
              variant="dot"
              onClick={handleMenu}
            >
              <Avatar
                alt="MarkeDesk"
                className={classes.avatar2}
                src={profileUrl}
              />
            </StyledBadge>

            <UserModal
              open={userModalOpen}
              onClose={() => setUserModalOpen(false)}
              onImageUpdate={(newProfileUrl) => setProfileUrl(newProfileUrl)}
              userId={user?.id}
            />

            <Menu
              id="menu-appbar"
              anchorEl={anchorEl}
              getContentAnchorEl={null}
              anchorOrigin={{
                vertical: "bottom",
                horizontal: "right",
              }}
              transformOrigin={{
                vertical: "top",
                horizontal: "right",
              }}
              open={menuOpen}
              onClose={handleCloseMenu}
              PaperProps={{
                style: {
                  minWidth: "150px",
                  maxWidth: "200px",
                  width: "auto",
                },
              }}
            >
              <MenuItem onClick={handleOpenUserModal}>
                {i18n.t("mainDrawer.appBar.user.profile")}
              </MenuItem>
              <MenuItem onClick={handleClickLogout}>
                {i18n.t("mainDrawer.appBar.user.logout")}
              </MenuItem>
            </Menu>
          </div>
        </Toolbar>
      </AppBar>
      <main className={classes.content}>
        <div className={classes.appBarSpacer} />
        <CompanyBlockingMiddleware>
          {children ? children : null}
        </CompanyBlockingMiddleware>
      </main>

      {/* Host de modais HTML de plugins (markedesk.openHtmlModal) */}
      <PluginHtmlModalHost />

      {/* Modal de Informativos */}
      <Dialog
        open={showAnnouncementsModal}
        onClose={() => setShowAnnouncementsModal(false)}
        maxWidth="md"
        fullWidth
      >
        <DialogTitle>Informativos</DialogTitle>
        <DialogContent dividers>
          {selectedAnnouncement ? (
            <div>
              <Typography variant="h6" gutterBottom>
                {selectedAnnouncement.title}
              </Typography>
              <Typography variant="body1" style={{ whiteSpace: 'pre-line' }}>
                {selectedAnnouncement.text}
              </Typography>
              {selectedAnnouncement.mediaPath && (
                <div style={{ marginTop: 16 }}>
                  <img
                    src={`${backendUrl}/public/company${user.companyId}${selectedAnnouncement.mediaPath}`}
                    alt="Anexo"
                    style={{ maxWidth: '100%' }}
                  />
                </div>
              )}
              <Button
                onClick={() => setSelectedAnnouncement(null)}
                style={{ marginTop: 16 }}
                variant="outlined"
              >
                Voltar para lista
              </Button>
            </div>
          ) : (
            <List>
              {announcements.map((announcement) => (
                <ListItem
                  button
                  key={announcement.id}
                  onClick={() => setSelectedAnnouncement(announcement)}
                >
                  <ListItemAvatar>
                    <Avatar>
                      <NotificationsIcon />
                    </Avatar>
                  </ListItemAvatar>
                  <ListItemText
                    primary={announcement.title}
                    secondary={
                      <>
                        <Typography
                          component="span"
                          variant="body2"
                          color="textPrimary"
                        >
                          Prioridade: {announcement.priority === 1 ? 'Alta' : announcement.priority === 2 ? 'Média' : 'Baixa'}
                        </Typography>
                        {` — ${new Date(announcement.createdAt).toLocaleDateString()}`}
                      </>
                    }
                  />
                </ListItem>
              ))}
            </List>
          )}
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() => setShowAnnouncementsModal(false)}
            color="primary"
          >
            Fechar
          </Button>
        </DialogActions>
      </Dialog>

      <SyncStatusOverlay />

      {/* Modal de Aniversário */}
      <BirthdayModal
        open={showBirthdayModal}
        onClose={() => setShowBirthdayModal(false)}
        user={user}
      />

      {/* Dialog de lembrete de tarefa */}
      <Dialog
        open={!!taskReminderData}
        onClose={() => setTaskReminderData(null)}
        maxWidth="xs"
        fullWidth
        PaperProps={{
          style: {
            borderRadius: 16,
            overflow: "hidden",
          },
        }}
      >
        <div style={{
          background: "linear-gradient(135deg, #ff9800 0%, #f44336 100%)",
          padding: "24px 24px 20px",
          display: "flex",
          alignItems: "center",
          gap: 12,
        }}>
          <NotificationsActiveIcon style={{ color: "#fff", fontSize: 32 }} />
          <Typography variant="h6" style={{ color: "#fff", fontWeight: 700 }}>
            {i18n.t("tasks.reminder.dialogTitle")}
          </Typography>
        </div>
        <DialogContent style={{ padding: "24px", textAlign: "center" }}>
          <Typography variant="h5" style={{ fontWeight: 700, marginBottom: 16 }}>
            {taskReminderData?.title}
          </Typography>
          {taskReminderData?.description && (
            <Typography variant="body1" color="textSecondary" style={{ marginBottom: 16 }}>
              {taskReminderData.description}
            </Typography>
          )}
          {taskReminderData?.startTime && (
            <div style={{
              display: "inline-flex",
              alignItems: "center",
              gap: 6,
              background: "#fff3e0",
              borderRadius: 8,
              padding: "8px 16px",
            }}>
              <AccessTimeIcon style={{ color: "#ff9800", fontSize: 20 }} />
              <Typography variant="body1" style={{ fontWeight: 600, color: "#e65100" }}>
                {i18n.t("tasks.reminder.dialogScheduledFor")} {taskReminderData.startTime}
              </Typography>
            </div>
          )}
        </DialogContent>
        <DialogActions style={{ padding: "12px 24px 20px", justifyContent: "center" }}>
          <Button
            onClick={() => setTaskReminderData(null)}
            variant="contained"
            style={{
              background: "linear-gradient(135deg, #ff9800 0%, #f44336 100%)",
              color: "#fff",
              fontWeight: 700,
              borderRadius: 8,
              padding: "10px 40px",
              fontSize: "1rem",
            }}
          >
            {i18n.t("tasks.reminder.dialogDismiss")}
          </Button>
        </DialogActions>
      </Dialog>

    </div>
    <GlobalAudioPlayer />
    </AudioPlayerProvider>
  );
};

export default LoggedInLayout;